import { ApiPaths } from 'api/constants';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import { ILicenseRepo, Licenses } from './ILicenses';

export class LicenseRepo extends BaseRepo implements ILicenseRepo {
  getLicenses = (): ApiResponseAsync<Licenses> =>
    this.helpers.handleGet(ApiPaths.licenses._());
}
